import { create } from "zustand";
import { persist } from "zustand/middleware";

/** Produit ajouté au panier marketing (instantané léger pour l'affichage). */
export interface MarketingCartItem {
	id: string;
	title: string;
	image: string | null;
	price: number | null;
	currency: string;
}

interface MarketingCartState {
	items: MarketingCartItem[];
	add: (item: MarketingCartItem) => void;
	addMany: (items: MarketingCartItem[]) => void;
	remove: (id: string) => void;
	clear: () => void;
	has: (id: string) => boolean;
}

/**
 * Panier marketing : sélection de produits qui survit à la navigation
 * (localStorage). Alimenté depuis le catalogue (sélection groupée) et la fiche
 * produit, consommé par la page /marketing/generateur.
 */
export const useMarketingCart = create<MarketingCartState>()(
	persist(
		(set, get) => ({
			items: [],
			add: (item) =>
				set((s) =>
					s.items.some((i) => i.id === item.id)
						? s
						: { items: [...s.items, item] },
				),
			addMany: (incoming) =>
				set((s) => {
					const known = new Set(s.items.map((i) => i.id));
					const fresh = incoming.filter((i) => !known.has(i.id));
					return fresh.length ? { items: [...s.items, ...fresh] } : s;
				}),
			remove: (id) => set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
			clear: () => set({ items: [] }),
			has: (id) => get().items.some((i) => i.id === id),
		}),
		{ name: "akwaba-marketing-cart" },
	),
);
